import { FileUploadDialogComponent } from '@/components/file-upload-dialog/file-upload-dialog.component';
import { PropertyDocViewComponent } from '@/components/property-doc-view/property-doc-view.component';
import { PropertyEquipmentDialogComponent } from '@/components/property-equipment-dialog/property-equipment-dialog.component';
import { PropertyEquipmentTableComponent } from '@/components/property-equipment-table/property-equipment-table.component';
import { ObjectUpdatedType } from '@/enums/ObjectUpdatedType.enum';
import { UserHelper } from '@/helpers/user.helper';
import { AppConfigService } from '@/services/app-config.service';
import { FileUploadType } from '@/services/file-upload.service';
import { NgIf } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PropertyCategory, RealProperty } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { PropertyDocViewComponent as PropertyDocViewComponent_1 } from '../../../components/property-doc-view/property-doc-view.component';
import { PropertyEquipmentTableComponent as PropertyEquipmentTableComponent_1 } from '../../../components/property-equipment-table/property-equipment-table.component';

@Component({
  selector: 'app-property-equipment',
  templateUrl: './property-equipment.component.html',
  styleUrls: ['./property-equipment.component.scss'],
  standalone: true,
  imports: [PropertyEquipmentTableComponent_1, NgIf, PropertyDocViewComponent_1]
})
export class PropertyEquipmentComponent implements OnInit, OnDestroy {
  @ViewChild(PropertyEquipmentTableComponent)
  equipmentTableComponent: PropertyEquipmentTableComponent;
  @ViewChild(PropertyDocViewComponent) docComponent: PropertyDocViewComponent;
  @Input() prop: RealProperty;

  category = PropertyCategory.EQUIPMENT;

  sub = new Subscription();

  constructor(public userHelper: UserHelper, private dialog: MatDialog, private appConfigService: AppConfigService) {}

  ngOnInit() {
    this.sub = this.appConfigService.objectUpdated.subscribe((type) => {
      if (type === ObjectUpdatedType.DOC) {
        this.refreshDocList();
      } else if (type === ObjectUpdatedType.EQUIPMENT) {
        this.loadData();
        this.refreshDocList();
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  loadData() {
    this.equipmentTableComponent.loadData();
  }

  addEquipment() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(PropertyEquipmentDialogComponent, {
        // width: '20rem'
        data: { prop: this.prop }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.equipmentTableComponent.loadData();
        }
      });
    }
  }

  uploadDocEquipment() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(FileUploadDialogComponent, {
        // width: '20rem'
        data: {
          uploadType: FileUploadType.DOC,
          props: [this.prop],
          defaultCategory: PropertyCategory.EQUIPMENT
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.refreshDocList();
        }
      });
    }
  }

  refreshDocList() {
    if (this.docComponent) {
      this.docComponent.loadDocList();
    }
  }

  updateProperty(prop: RealProperty) {
    this.prop = prop;
    this.equipmentTableComponent.prop = prop;
    this.equipmentTableComponent.loadData();
    this.docComponent.prop = prop;
    this.refreshDocList();
  }
}
